module.exports = __webpack_public_path__ + "static/img/saleicon3.0d54f36.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/saleicon3.png
// module id = e3KV
// module chunks = 2